import { render, staticRenderFns } from "./TotalWithdrawModal.vue?vue&type=template&id=b9da880a&scoped=true"
import script from "./TotalWithdrawModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TotalWithdrawModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TotalWithdrawModal.vue?vue&type=style&index=0&id=b9da880a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9da880a",
  null
  
)

export default component.exports